import React, {useEffect, useState} from 'react';
import i18next from 'i18next';
import {dynamicSortWithTraduction} from '../utils/sort';
import ContextMenu from './ContextMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiceD20 } from '@fortawesome/free-solid-svg-icons';

const Skills = (props) => {
  const skillList = props.skills.filter(skill => !skill.isSpecial);
  const [x, setX] = useState(0);
  const [y, setY] = useState(0);
  const [showMenu, setShowMenu] = useState(false);
  const [skillWithModifier, setSkillWithModifier] = useState({});

  const handleContextMenu = (e) => {
    e.preventDefault();
    const el = e.target.closest('[data-skill]');
    if (!el) return;
    setSkillWithModifier(JSON.parse(el.getAttribute('data-skill')));
    e.pageX + 250 > window.innerWidth ? setX(`${window.innerWidth - 270}px`) : setX(e.pageX);
    e.pageY + 115 > window.innerHeight ? setY(`${window.innerHeight - 135}px`) : setY(e.pageY);
    setShowMenu(true);
  }

  const handleClick = (e) => {
    if(showMenu && e.target.id === 'blockMenu') {
      setShowMenu(false);
      setSkillWithModifier({});
    }
  }

  useEffect(() => {
    if(props.campaign.clickStat) {
      const box = document.getElementById('skillsBox');
      document.addEventListener('click',handleClick)
      box.addEventListener('contextmenu',handleContextMenu)
      return () => {
        document.removeEventListener('click', handleClick);
        box.removeEventListener('contextmenu', handleContextMenu);
      }
    }
  })

  return (
    <>
      <ContextMenu
        x={x}
        y={y}
        showMenu={showMenu}
        stat={skillWithModifier}
        prefix='skills'
        rollDice={(skillModifier) => {
          setShowMenu(false);
          props.onRollStat(skillModifier, 'skills');
        }}
      />
      <ul id='skillsBox' className={props.campaign.clickStat ? 'clickable' : ''}>
          {
          skillList.sort(dynamicSortWithTraduction("label", 'skills')).map((skill,i) => (
            <li
              style={{cursor: props.campaign.clickStat ? 'pointer' : 'default'}}
              key={i}
              data-skill={JSON.stringify(skill)}
              data-tooltip={props.campaign.clickStat ? i18next.t('skillClickHint') : undefined}
              onClick={() => {
                if(props.campaign.clickStat) {
                  props.onRollStat(skill, 'skills');
                }

              }}
            >
              <div className='skillMainRow'>
                <span>
                  {skill.isCustom ? skill.label : i18next.t(`skills.${skill.label}`)}
                </span>
                <span className='skillValueWrapper'>
                  {props.campaign.clickStat && (
                    <FontAwesomeIcon icon={faDiceD20} className='skillDiceHint' />
                  )}
                  {skill.value}
                </span>
              </div>
              {skill.note && (
                <span className='skillNote'>{skill.note}</span>
              )}
            </li>
          ))
        }
      </ul>
    </>
  );

}

export default Skills
